module.exports = __webpack_public_path__ + "img/avatar3.83ca1aca.png";